import React from "react";
import Card from "./Card";
import netmeds from "../../assets/img/projects/netmeds.png";
import movie from "../../assets/img/projects/movie.png";
import todo from "../../assets/img/projects/todo.png";
import startEngine from "../../assets/img/projects/startengine.png";
import airbnb from "../../assets/img/projects/airbnb.png";
import gadgets from "../../assets/img/projects/gadgets.png";

const Project = () => {
  const project = {
    data: [
      {
        name: "Gadgets Cloud",
        desc: "Gadgets-Cloud is an e-commerce platform. Which allows the user to search the gadgets of different category & purchase the gadgets.",
        img: gadgets,
        demoLink: "https://gadgets-cloud.herokuapp.com/",
        codeLink: "https://github.com/vaibhav-raj/Gadgets-Cloud",
        techstack: [
          "/icons/react.svg",
          "/icons/redux.svg",
          "/icons/material-ui.svg",
          "/icons/mongodb.svg",
          "/icons/express.svg",
          "/icons/nodejs-icon.svg",
        ],
      },
      {
        name: "Airbnb Clone",
        desc: "Airbnb is an online marketplace that connects people who want to rent out their homes with people who are looking for accommodations in that locale.",
        img: airbnb,
        demoLink: "https://airbnb-clone-one-weld.vercel.app/",
        codeLink: "https://github.com/ks-1007/Airbnb-clone",
        techstack: [
          "/icons/html-5.svg",
          "/icons/css-3.svg",
          "/icons/react.svg",
          "/icons/redux.svg",
          "/icons/material-ui.svg",
        ],
      },
      {
        name: "StartEngine Clone",
        desc: "StartEngine is a U.S based trading platform where user can invest their money in start-ups and big companies.",
        img: startEngine,
        demoLink: "https://startengine-clone.netlify.app/",
        codeLink: "https://github.com/vaibhav-raj/StartEngine-Clone",
        techstack: [
          "/icons/html-5.svg",
          "/icons/css-3.svg",
          "/icons/react.svg",
        ],
      },
      {
        name: "Netmeds Clone",
        desc: "Netmeds is a Indian online pharmacy which provides the online purchase & fast delivery of medications.",
        img: netmeds,
        demoLink: "https://vaibhav-raj.github.io/NetmedsClone/",
        codeLink: "https://github.com/vaibhav-raj/NetmedsClone",
        techstack: [
          "/icons/html-5.svg",
          "/icons/css-3.svg",
          "/icons/javascript.svg",
        ],
      },
    ],
  };
  return (
    <>
      <div id="projects" className="container">
        <h1 className="pt-3 text-center font-details-b pb-3">PROJECTS</h1>
        <div className="row">
          {project.data.map((elem, index) => {
            return <Card key={index} data={elem} />;
          })}
        </div>
      </div>
    </>
  );
};

export default Project;
